"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require("../../../sass/themes/dark.sass");
require("../../../sass/pages/sign-up.sass");

var $body = void 0;

var Metrics = void 0;
var Pricing_Signup_Form = void 0;
var user = void 0;

$body = require("../helpers/helpers").default.body;

Metrics = require("../helpers/metrics").default;

user = require("../helpers/noun_user").default;

var Signup_Form = function () {
    function Signup_Form() {
        _classCallCheck(this, Signup_Form);

        this.$useEmailBtn = (0, _jquery2.default)("#button-use-email");
        this.$createAccoutBtn = (0, _jquery2.default)("#button-create-account");
        this.$sign_up_fields = (0, _jquery2.default)(".sign-up-fields");
        this.$disclaimer = (0, _jquery2.default)(".disclaimer .must-agree");

        this.use_email_option();
        this.check_errors();
        this.set_submit();
    }

    _createClass(Signup_Form, [{
        key: "use_email_option",
        value: function use_email_option() {
            var _this = this;

            var me = void 0;
            me = this;
            return this.$useEmailBtn.on("click", function (e) {
                e.preventDefault();
                _this.$useEmailBtn.addClass("hidden");
                _this.$createAccoutBtn.removeClass("hidden");

                me.$sign_up_fields.removeClass("collapsed");
                (0, _jquery2.default)(".disclaimer").removeClass("hidden");
                if ((0, _jquery2.default)("#id_team_name").length !== 0) {
                    return (0, _jquery2.default)("#id_team_name").focus();
                } else {
                    return (0, _jquery2.default)("#id_full_name").focus();
                }
            });
        }
    }, {
        key: "check_errors",
        value: function check_errors() {
            if ((0, _jquery2.default)("input.error").length !== 0) {
                this.$useEmailBtn.addClass("hidden");
                this.$createAccoutBtn.removeClass("hidden");
                this.$sign_up_fields.removeClass("collapsed");
            }
        }
    }, {
        key: "set_submit",
        value: function set_submit() {
            var me = void 0;
            me = this;
            return (0, _jquery2.default)("form#create-account").on("submit", function (e) {
                var $this = void 0;
                $this = (0, _jquery2.default)(this);
                if ((0, _jquery2.default)(this).data("submitted") !== true) {
                    (0, _jquery2.default)(this).attr("data-submitted", "true");
                    return true;
                } else {
                    return false;
                }
                return me.$disclaimer.on("click", function (e) {
                    return (0, _jquery2.default)(this).removeClass("visible");
                });
            });
        }
    }]);

    return Signup_Form;
}();

exports.default = Signup_Form;